module.exports = __webpack_public_path__ + "static/media/aboutus.0db617c2.png";